import React, { useMemo, useState, useReducer, useEffect } from 'react'
import { Flex, Box } from 'reflexbox/styled-components'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import Breadcrumb from 'components/Breadcrumb'
import MoneyFormat from 'components/MoneyFormat'
import Button from 'components/Button'
import { Title, Text, SemiTitle } from 'components/Typography'

import { Table, TableCell, TableFooter } from './styles'
import theme from 'styles/theme'

import { reducer } from 'helpers/loadingReducer'
import { getOrder } from 'services/orders'
import Loader from 'components/Loader'

const PurchaseDetail = () => {
  const { id: orderId } = useParams()
  const [requestStatus, dispatch] = useReducer(reducer, { isLoading: true, error: false })
  const [paymentURL, setPaymentURL] = useState(null)
  const [order, setOrder] = useState([])
  const [paymentConfirmation, setPaymentConfirmation] = useState(null)
  const [isOrderNoPayment, setOrderNoPayment] = useState(true)
  const [totalOrder, setTotalOrder] = useState({
    total_quantity: 0,
    total_price: 0,
  })

  const breadcrumbPath = useMemo(
    () => [
      {
        label: 'Histórico de compras',
        link: '/staff/prepaid-partners/purchase-history',
      },
      {
        label: `Pedido ${orderId}`,
      },
    ],
    [orderId],
  )

  useEffect(() => {
    const getOrderResume = async () => {
      try {
        const { data } = await getOrder(orderId)

        setOrder(data.items)
        setPaymentConfirmation(data.is_payment_confirmed)
        setPaymentURL(data.is_payment_confirmed ? data.boleto?.receipt : data.boleto?.payment_url)
        setOrderNoPayment(data.payment_type === 'no-payment')
        dispatch({ type: 'success' })
      } catch (e) {
        console.log(e)
        toast.error('Erro ao recuperar dados do pedido!')
        dispatch({ type: 'error' })
      }
    }

    getOrderResume()
  }, [])

  useEffect(() => {
    setTotalOrder(
      order.reduce(
        (acc, curr) => ({
          total_price: acc.total_price + Number(curr.unit_price) * curr.quantity,
          total_quantity: acc.total_quantity + curr.quantity,
        }),
        { total_price: 0, total_quantity: 0 },
      ),
    )
  }, [order])

  return (
    <Flex width={1} flexDirection='column'>
      <Breadcrumb children={breadcrumbPath} />

      <Box mb={32}>
        <Title as='h3'>Pedido {orderId}</Title>
        {isOrderNoPayment ? (
          <Text color={theme.colors.grays.N500}>Pacotes concedidos pela Guigo TV.</Text>
        ) : paymentConfirmation ? (
          <Text color={theme.colors.grays.N500}>
            Pagamento confirmardo. Os pacotes já estão contabilizados no seu saldo.
          </Text>
        ) : (
          <Text color={theme.colors.grays.N500}>
            Compra finalizada com sucesso. Os pacotes serão liberados após a confirmação do pagamento.
          </Text>
        )}
      </Box>
      <Box mb={64}>
        <a target='blank' href={paymentURL}>
          {!isOrderNoPayment && (
            <Button size='big' disabled={requestStatus?.error}>
              {paymentConfirmation ? 'Visualizar Recibo' : 'Visualizar boleto'}
            </Button>
          )}
        </a>
      </Box>

      <SemiTitle as='h3'>Resumo do pedido</SemiTitle>
      {requestStatus?.isLoading ? (
        <Flex width={1} justifyContent='center' mt={32}>
          <Loader />
        </Flex>
      ) : requestStatus.error ? (
        <Text>Não foi possivel recuperar os dados da sua compra no momento, tente novamente mais tarde!</Text>
      ) : (
        <Table>
          <thead>
            <tr>
              <TableCell as='th' align='left' color='#989898' fontSize={20} fontWeight='800'>
                Pacotes de canais
              </TableCell>
              <TableCell as='th' color='#989898' fontSize={20} fontWeight='800'>
                Quantidade
              </TableCell>
              <TableCell as='th' color='#989898' fontSize={20} fontWeight='800'>
                Valor
              </TableCell>
              <TableCell as='th' color={theme.colors.turquoises.T300} fontSize={20} fontWeight='800'>
                Valor Total
              </TableCell>
            </tr>
          </thead>
          <tbody>
            {order?.map((plan, index) => (
              <tr key={index}>
                <TableCell align='left'>{plan.package_name}</TableCell>
                <TableCell>{plan.quantity}</TableCell>
                <TableCell>
                  <MoneyFormat value={Number(plan.unit_price)} />
                </TableCell>
                <TableCell color={theme.colors.turquoises.T300} fontWeight='800'>
                  <MoneyFormat value={Number(plan.unit_price) * plan.quantity} />
                </TableCell>
              </tr>
            ))}
          </tbody>
          <TableFooter>
            <tr>
              <TableCell align='left'>Total</TableCell>
              <TableCell>{totalOrder?.total_quantity}</TableCell>
              <TableCell />
              <TableCell color={theme.colors.turquoises.T300} fontWeight='800'>
                <MoneyFormat value={totalOrder?.total_price} />
              </TableCell>
            </tr>
          </TableFooter>
        </Table>
      )}
    </Flex>
  )
}

export default PurchaseDetail
